import { gql } from '@apollo/client';

export const GET_MASTER_CHANGES = gql`
  query GetMasterChanges {
    vm {
      enterpriseMasterChanges {
        entityType
        entityId
        name
        changeSummary
        changeCount
        lastSharedAt
        changes {
          diffType
          entityType
          entityId
          fieldPath
          fieldLabel
          entityLabel
          itemName
          itemFieldType
          previousValue
          newValue
          summary
        }
      }
    }
  }
`;
